import { apiGet } from '../utils/api'

//GET APIS
export const getOrganizationsAPI = () => {
  return apiGet('mgmt/organization')
}



// WEBPACK FOOTER //
// ./src/api/organization.js